import { Solar } from "lunar-typescript";

const zodiac = [
  "鼠",
  "牛",
  "虎",
  "兔",
  "龙",
  "蛇",
  "马",
  "羊",
  "猴",
  "鸡",
  "狗",
  "猪",
];

function rearrangeArray<T>(array: T[], i: number): T[] {
  if (i < 0 || i >= array.length) {
    throw new Error("Invalid index");
  }

  const reversedPart = array.slice(0, i + 1).reverse();
  const remainingPart = array.slice(i + 1).reverse();

  return reversedPart.concat(remainingPart);
}

function getZodiacList(openTime: number) {
  let current = Solar.fromDate(new Date(openTime)).getLunar().getYear();
  current = (current % 12) - 4;
  current = current < 0 ? current + 12 : current;
  return rearrangeArray(zodiac, current);
}

export function getZodiac(num: number, openTime: number) {
  return getZodiacList(openTime)[(num - 1) % 12] ?? "";
}

export function getCodeSelectorName(num: number | string) {
  const index = typeof num === "string" ? Number(num) : num;
  if (index === 0) {
    return "正码一";
  }
  if (index === 1) {
    return "正码二";
  }
  if (index === 2) {
    return "正码三";
  }
  if (index === 3) {
    return "正码四";
  }
  if (index === 4) {
    return "正码五";
  }
  if (index === 5) {
    return "正码六";
  }
  if (index === 6) {
    return "特码";
  }
  return "总和";
}

export function getTypeSelectorName(num: number | string) {
  const index = typeof num === "string" ? Number(num) : num;
  if (index === 0) {
    return "单双";
  }
  if (index === 1) {
    return "大小";
  }
  return "全选";
}
